import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";

const SOCIALS = [
  { icon: "bi-facebook", href: "https://facebook.com" },
  { icon: "bi-instagram", href: "https://instagram.com" },
  { icon: "bi-twitter-x", href: "https://twitter.com" },
  { icon: "bi-youtube", href: "https://youtube.com" },
];

export default function LandingFooter() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    window.location.href = `mailto:info@padelkingdom.ae?subject=Newsletter%20signup&body=${encodeURIComponent(
      email
    )}`;
    setEmail("");
  };

  return (
    <footer id="contact" className="hl-footer">
      <div className="hl-footer__top">
        <div className="hl-footer__brand">
          <img src={logo} alt="Padel Kingdom" />
          <p>
            Relive, recover and perform at your best with Padel Kingdom's
            guided recovery therapies — bookable in a few taps.
          </p>
          <div className="hl-footer__socials">
            {SOCIALS.map((s) => (
              <a key={s.icon} href={s.href} target="_blank" rel="noreferrer" aria-label={s.icon}>
                <i className={`bi ${s.icon}`} />
              </a>
            ))}
          </div>
        </div>

        <div className="hl-footer__col">
          <h4>Company</h4>
          <a href="#home">Home</a>
          <a href="#hl-services">Services</a>
          <a href="#download">Download App</a>
          <Link to="/terms">Terms &amp; Conditions</Link>
        </div>

        <div className="hl-footer__col">
          <h4>Contact</h4>
          <a href="tel:+971502742386">+971 50 274 2386</a>
          <a href="https://padelkingdom.ae" target="_blank" rel="noreferrer">
            www.padelkingdom.ae
          </a>
          <a href="mailto:info@padelkingdom.ae">info@padelkingdom.ae</a>
          <span>United Arab Emirates</span>
        </div>

        <div className="hl-footer__col hl-footer__newsletter">
          <h4>Get the latest information</h4>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" aria-label="Subscribe">
              <i className="bi bi-send-fill" />
            </button>
          </form>
        </div>
      </div>

      <div className="hl-footer__bottom">
        <p>Copyright &copy; {new Date().getFullYear()} Padel Kingdom. All Rights Reserved.</p>
        <div>
          <Link to="/terms">Terms &amp; Conditions</Link>
          <span>-</span>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
